import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, State, selectAll, selectEntities, selectIds, selectTotal } from './method-option-category.reducer';

export const selectMethodOptionCategoryState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectMethodOptionCategoryState, (state: State) => state.error);

export const getLoaded = createSelector(selectMethodOptionCategoryState, (state: State) => state.loaded);

export const getAll = createSelector(selectMethodOptionCategoryState, selectAll);

export const getCount = createSelector(selectMethodOptionCategoryState, selectTotal);

export const getIds = createSelector(selectMethodOptionCategoryState, selectIds);

export const getAllEntities = createSelector(selectMethodOptionCategoryState, selectEntities);
